import { CSSProperties } from 'react';

export const getUrlEncodedCircle = (
  color: CSSProperties['color'],
  width: CSSProperties['width'] = '0.5rem',
): string => {
  const encoded = encodeURIComponent(
    `<svg height="${width}" width="${width}" viewBox="0 0 10 10"
      fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="5" cy="5" r="5" fill="${color}" />
    </svg>`,
  );
  return `url(data:image/svg+xml,${encoded})`;
};

export const getUrlEncodedSquare = (
  color: CSSProperties['color'],
  width: CSSProperties['width'] = '0.5rem',
): string => {
  const encoded = encodeURIComponent(
    `<svg height='${width}' width='${width}' viewBox='0 0 10 10'
      fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0' y='0' width='10' height='10' fill='${color}' />
    </svg>`,
  );
  return `url(data:image/svg+xml,${encoded})`;
};

export const getUrlEncodedTriangle = (
  color: CSSProperties['color'],
  width: CSSProperties['width'] = '0.5rem',
): string => {
  const encoded = encodeURIComponent(
    `<svg height='${width}' width='${width}' viewBox='0 0 10 10'
      fill='none' xmlns='http://www.w3.org/2000/svg'>
      <polygon points='0,0,10,5,0,10' fill="${color}" />
    </svg>`,
  );
  return `url(data:image/svg+xml,${encoded})`;
};

export const getUrlEncodedDiamond = (
  color: CSSProperties['color'],
  width: CSSProperties['width'] = '0.5rem',
): string => {
  const h = Number(10 / Math.sqrt(2)).toFixed(3);
  const encoded = encodeURIComponent(
    `<svg height='${width}' width='${width}' viewBox='0 0 10 10'
      fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='5' y='0' width='${h}' height='${h}' fill='${color}' transform='rotate(45 5 0)' />
    </svg>`,
  );
  return `url(data:image/svg+xml,${encoded})`;
};
